import { create } from "zustand";
import { persist } from "zustand/middleware";

const DEFAULT_EXCLUDED_TYPES = ["watch", "link", "youtube"];

interface OverdueFilterState {
  excludedTypes: string[];
  hydrated: boolean;
  setExcludedTypes: (types: string[]) => void;
  toggleType: (typeName: string) => void;
  includeAll: () => void;
  excludeAll: (allTypes: string[]) => void;
  setHydrated: (hydrated: boolean) => void;
}

export const useOverdueFilterStore = create<OverdueFilterState>()(
  persist(
    (set, get) => ({
      excludedTypes: DEFAULT_EXCLUDED_TYPES,
      hydrated: false,
      setExcludedTypes: (types: string[]) => set({ excludedTypes: types }),
      toggleType: (typeName: string) => {
        const { excludedTypes } = get();
        if (excludedTypes.includes(typeName)) {
          set({ excludedTypes: excludedTypes.filter((t) => t !== typeName) });
        } else {
          set({ excludedTypes: [...excludedTypes, typeName] });
        }
      },
      includeAll: () => set({ excludedTypes: [] }),
      excludeAll: (allTypes: string[]) => set({ excludedTypes: allTypes }),
      setHydrated: (hydrated: boolean) => set({ hydrated }),
    }),
    {
      name: "overdue-filter-storage",
      partialize: (state) => ({ excludedTypes: state.excludedTypes }),
      onRehydrateStorage: () => (state) => {
        state?.setHydrated(true);
      },
    },
  ),
);
